import React, { useState, useRef, useEffect, useLayoutEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import OtpInput from "react-otp-input";
import Grid from "@mui/material/Grid";
import $ from "jquery";
import { useLocation, useSearchParams } from "react-router-dom";
import { getAuth } from "../../redux/slices/authSlice";
import {
  CarouselProvider,
  Slider,
  Slide,
  ButtonBack,
  ButtonNext,
  DotGroup,
} from "pure-react-carousel";
import "pure-react-carousel/dist/react-carousel.es.css";
import { getUser, getUserToken } from "../../libs/user";
import { inputFormat, phoneValidation } from "../../utils/validation";
import { NUMBER, downloadApp } from "../../libs/utils";
import AppSkeleton from "../../components/Skeletons/AppSkeleton";
import star from "../../assets/img/star.svg";
import cricbuzzQr from "../../assets/img/cricbuzzQr.png";
import BackArrow from "../../assets/img/BackArrow.svg";
import { CRICBUZZ_SLIDER_ITEMS } from "../../constants";
import FeatureNotAvailable from "../../components/modal/FeatureNotAvailable";
import {
  cricbuzzResendMsgService,
  cricbuzzResendOtpService,
  cricbuzzSendOtpService,
  cricbuzzVerifyOtpService,
} from "../../services/remittance";
import {
  Cricbuzz_phone_number_added,
  Cricbuzz_phone_number_screen_landed,
  Cricbuzz_phone_number_verified,
} from "../../libs/events";

function Signup() {
  const [searchParams] = useSearchParams();

  const action_type = searchParams.get("action_type");
  const token = searchParams.get("token");
  const id = searchParams.get("id");
  const mobileNumber = searchParams.get("mobile_number");
  const email = searchParams.get("email");
  const cashback_eligible = searchParams.get("cashback_eligible");
  // const formattedNumber = mobileNumber?
  //   mobileNumber?.indexOf("+") === 0
  //     ? mobileNumber
  //     : `+${mobileNumber?.replace(" ", "")}`:'';

  const subscription_plan = searchParams.get("subscription_plan");
  const [verifiedToken, setVerifiedToken] = useState("");

  const [isSubmitSignup, setSubmitSignup] = useState(false);
  const [screentype, setScreenType] = useState(1);
  const [counter, setCounter] = useState(0);
  const [loader, setLoader] = useState(false);

  const [bodyHeight, setBodyHeight] = useState();
  const [phone, setPhone] = useState("");
  const [sendOTPSuccess, setSendOTPSuccess] = useState(false);

  const [phoneError, setPhoneError] = useState("");

  const [otp, setOtp] = useState("");

  const form = useRef();

  const NAME = /^[A-Za-z]+$/;

  const allowedRegex = /^(?=.*[0-9])[- +()0-9]+$/;

  const dispatch = useDispatch();

  const [messageId, setMessageId] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [resendOtpMsg, setResendOtpMsg] = useState("");

  const authToken = getUserToken();

  const handleSignup = (data) => {
    if (validatePhone()) {
      const input = ("+1" + phone).replace(/[- )(]/g, "");
      setLoader(true);
      cricbuzzSendOtpService({
        id: id,
        mobile_number: input,
        token: token,
        action_type: action_type,
      })
        .then((response) => {
          setErrorMsg("");
          setLoader(false);
          setMessageId(response.message_id);
          Cricbuzz_phone_number_added({
            email: email,
            phone_number: input,
            subscription_plan: subscription_plan,
          });
          setPhoneError("");
          setScreenType(2);
          dispatch(getAuth());
        })
        .catch((error) => {
          setErrorMsg(error?.response?.data?.error?.message);
          setSubmitSignup(false);
          setLoader(false);
        });
    }
  };

  const handleVerifyOtp = () => {
    if (otp.length === 6) {
      if (isValidForm()) {
        const input = ("+1" + phone).replace(/[- )(]/g, "");
        setLoader(true);
        cricbuzzVerifyOtpService({
          message_id: messageId,
          mobile_number: input,
          otp,
        })
          .then((response) => {
            setVerifiedToken(response.app_link_token);
            Cricbuzz_phone_number_verified({
              email: email,
              phone_number: input,
              subscription_plan: subscription_plan,
            });
            setErrorMsg("");
            setLoader(false);
            setScreenType(3);
            setLoader(false);
            setOtp("");
          })
          .catch((error) => {
            setVerifiedToken("");
            if (error?.error?.code === 4013 || error?.error?.code === 9002) {
              console.log(error);
            }
            setLoader(false);
            setErrorMsg(error?.response?.data?.error?.message);
          });
      }
    } else {
      setErrorMsg("Please enter valid otp");
    }
  };

  useEffect(() => {
    if (action_type === "UPDATE_MOBILE_NUMBER") {
      setScreenType(1);
    }
    if (action_type === "SEND_APP_LINK") {
      setScreenType(3);
    }
  }, []);

  useEffect(() => {
    if (screentype === 1 && action_type === "UPDATE_MOBILE_NUMBER") {
      Cricbuzz_phone_number_screen_landed({
        email,
        subscription_plan,
      });
    }
  }, [screentype]);

  const handleResendOTP = () => {
    setSendOTPSuccess(false);
    setOtp("");
    const input = ("+1" + phone).replace(/[- )(]/g, "");
    setLoader(true);
    cricbuzzResendOtpService({
      mobile_number: input,
      message_id: messageId,
    })
      .then((response) => {
        setErrorMsg("");
        setLoader(false);
        setErrorMsg("");
        setSendOTPSuccess(true);
      })
      .catch((error) => {
        setErrorMsg(error?.response?.data?.error?.message);
        setLoader(false);
        setSendOTPSuccess(false);
      });
  };

  const handleResendMessage = () => {
    const input = ("+1" + phone).replace(/[- )(]/g, "");
    setLoader(true);
    setResendOtpMsg("");
    cricbuzzResendMsgService({
      token: action_type === "SEND_APP_LINK" ? token : verifiedToken,
      notification_method: "SMS",
      identifier:
        action_type === "SEND_APP_LINK"
          ? `+${mobileNumber?.replace(" ", "")}`
          : input,
    })
      .then((response) => {
        setLoader(false);
        setErrorMsg("");
        setResendOtpMsg(response?.message);
      })
      .catch((error) => {
        setErrorMsg(error?.response?.data?.error?.message);
        setLoader(false);
        setResendOtpMsg("");
      });
  };
  const handleOtpChange = (value) => {
    if (NUMBER.test(Number(value))) {
      setOtp(value);
    }
  };

  const handleKey = (e) => {
    if (!e.key.match(allowedRegex)) {
      e.preventDefault();
    }
  };

  const handleChange = (e) => {
    const tempVal = inputFormat(e);
    if (!tempVal) {
      setPhone("");
      setPhoneError("");
      return;
    }
    if (tempVal) {
      if (tempVal.length === 0) {
        setSubmitSignup(true);
        setPhoneError("Field cannot be empty");
      } else {
        setSubmitSignup(false);
      }
      setPhone(tempVal);
      setPhoneError("");
    }
  };

  const validatePhone = () => {
    const formattedPhone = phoneValidation(phone);
    if (formattedPhone) {
      setPhone(formattedPhone);
      setPhoneError("");
      return true;
    } else {
      setPhoneError("Invalid Phone Number");
      return false;
    }
  };

  useEffect(() => {
    if (!phone && action_type === "UPDATE_MOBILE_NUMBER") {
      setSubmitSignup(true);
      setScreenType(1);
    }
    return () => {
      setErrorMsg("");
      setPhoneError("");
      setSendOTPSuccess(false);
    };
  }, []);

  useEffect(() => {
    if (screentype === 2) setCounter(60);
  }, [screentype]);

  useEffect(() => {
    if (screentype === 2) {
      counter > 0 && setTimeout(() => setCounter(counter - 1), 1000);
    }
  }, [screentype, counter]);

  const isValidForm = () => {
    if (!otp || otp.length !== 6) {
      return false;
    }
    return true;
  };

  useEffect(() => {
    if (sendOTPSuccess) {
      setCounter(60);
    }
  }, [sendOTPSuccess]);

  useLayoutEffect(() => {
    const headerHeight = $(".header").outerHeight();
    const footerHeight = $(".footer").outerHeight();
    setBodyHeight(
      parseFloat($(window).outerHeight() || 0) -
        (parseFloat(headerHeight || 0) + parseFloat(footerHeight || 0))
    );
  }, []);

  const downloadApp = () => {
    let url = "https://ddl.joinabound.com/Iiw9/tqkq1wos";
    window.open(url, "_blank");
  };

  const handleBack = () => {
    setScreenType(1);
    setErrorMsg("");
  };

  return (
    <>
      <div className="mainContainer">
        <div className="upperContainer">
          <div className="containtSec">
            <div>
              <div>
                <div className="pb0-mob">
                  <div className="hedSec">
                    {screentype === 1 && (
                      <>
                        <div className="header">
                          Your {subscription_plan === "MONTHLY" && "$10"}
                          {subscription_plan === "YEARLY" && "$15"} cash back is
                          waiting for you
                        </div>
                        <div className="abound">
                          Simply verify your phone number to claim the cash back
                          on <span className="aboundTxt">Abound</span>
                        </div>
                      </>
                    )}

                    {screentype === 3 && (
                      <div className="linkContainer">
                        <div className="headerBox">
                          <div className="header">
                            {cashback_eligible === "false"
                              ? "Sorry, You're Not Eligible for Cash Back"
                              : "  Your cash back is credited"}
                          </div>

                          <div style={{ marginBottom: "24px" }}>
                            <div className="descrText">
                              {cashback_eligible === "false" ? (
                                `We regret to inform that you are not eligible for the cash back as your account is already registered on Abound app and redeemed this offer. You can login into the app to explore the latest deals available for you.`
                              ) : (
                                <>
                                  <span>
                                    We have sent an SMS with an app download
                                    link to{" "}
                                  </span>
                                  <span className="phoneText">
                                    {action_type === "SEND_APP_LINK"
                                      ? `+${mobileNumber?.replace(" ", "")}`
                                      : `+1 ${phone}`}
                                  </span>
                                  <span>
                                    . Login to your account to redeem the cash
                                    back.
                                  </span>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                        {loader ? (
                          <AppSkeleton
                            height={84}
                            width="100%"
                            className="btnLoader"
                          />
                        ) : (
                          <div>
                            <button
                              disabled={isSubmitSignup}
                              onClick={handleResendMessage}
                              className={
                                isSubmitSignup
                                  ? `btnResend disabled`
                                  : `btnResend blockBtn`
                              }
                            >
                              Resend sms
                            </button>
                          </div>
                        )}
                        {resendOtpMsg && !errorMsg && (
                          <div>
                            <span className="errorMsg">{resendOtpMsg}</span>
                          </div>
                        )}
                        {errorMsg && (
                          <div>
                            <span className="errorMsg">{errorMsg}</span>
                          </div>
                        )}
                        <div className="rating">
                          <span className="downloadText">
                            Other ways to download
                          </span>
                        </div>
                        <div className="feature">
                          <FeatureNotAvailable
                            displayText={false}
                            defaultQR={cricbuzzQr}
                            downloadPath={true}
                            downloadApp={() => downloadApp()}
                          />
                        </div>
                      </div>
                    )}

                    {screentype === 2 && (
                      <div className="verifyHeader">
                        <div className="backBtnBox">
                          <img
                            src={BackArrow}
                            alt="BackArrow"
                            className="cricbuzzBackBtn"
                            onClick={() => handleBack()}
                          />
                          <h2 className="verifyHeading">
                            Verify your Phone Number
                          </h2>

                          <div className="verifyBox">
                            We sent a 6 digit code to +1{" "}
                            <span className="verifiedNumber">{phone}</span>.
                            <br />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  <>
                    <div id="iPhoneUser">
                      <div className="formGroup">
                        <div className="signupContainer">
                          <div className="signupFields">
                            {screentype === 1 && (
                              <>
                                <div className={`cricbuzzInput`}>
                                  <span className="code">+1</span>
                                  <input
                                    className="mobileInput "
                                    id="phone"
                                    value={phone}
                                    placeholder=" Phone Number"
                                    onChange={handleChange}
                                    onKeyPress={handleKey}
                                    type="tel"
                                    maxLength={14}
                                  />
                                </div>

                                <div className="inputBorder"></div>
                                {errorMsg && !phoneError && (
                                  <div>
                                    <span className="errorMsg">{errorMsg}</span>
                                  </div>
                                )}
                                {phoneError && (
                                  <span className={`formControlMessage`}>
                                    {phoneError}
                                  </span>
                                )}
                              </>
                            )}

                            {screentype === 2 && (
                              <div className="verifySec">
                                <div className="verifyHeader">
                                  <div className={`otpInputContainer`}>
                                    <OtpInput
                                      shouldAutoFocus={true}
                                      numInputs={6}
                                      value={otp}
                                      onChange={handleOtpChange}
                                      inputStyle={`cricbuzzOtp`}
                                      className={`formGroupOtp`}
                                      renderInput={(props) => (
                                        <input
                                          {...props}
                                          disabled={loader}
                                          type="number"
                                          inputMode="numeric"
                                        />
                                      )}
                                      focusStyles="focusStyle"
                                    />
                                  </div>

                                  {errorMsg && (
                                    <span className="errorMsg">{errorMsg}</span>
                                  )}
                                </div>
                              </div>
                            )}
                          </div>
                        </div>

                        {screentype === 2 && (
                          <div className="resendSec">
                            {sendOTPSuccess && (
                              <div className={`resendOTPtext`}>
                                New Code Sent!
                              </div>
                            )}
                            {counter !== 0 ? (
                              <div className="resendHeader">{`Resend code in ${counter}s`}</div>
                            ) : (
                              <div className={`resendText`}>
                                <span onClick={handleResendOTP}>
                                  {"Send Code Again->"}
                                </span>
                              </div>
                            )}
                          </div>
                        )}
                        {screentype === 1 && (
                          <>
                            {loader ? (
                              <AppSkeleton
                                height={84}
                                width="100%"
                                className="btnLoader"
                              />
                            ) : (
                              <div>
                                <button
                                  disabled={isSubmitSignup}
                                  onClick={handleSignup}
                                  className={
                                    isSubmitSignup
                                      ? `btnVerify disabled`
                                      : `btnVerify blockBtn`
                                  }
                                >
                                  Get Started
                                </button>
                              </div>
                            )}
                          </>
                        )}

                        {screentype === 2 && (
                          <div className="verifySec">
                            {loader ? (
                              <AppSkeleton
                                height={84}
                                width="100%"
                                className="btnLoader"
                              />
                            ) : (
                              <div>
                                <button
                                  disabled={isSubmitSignup}
                                  onClick={handleVerifyOtp}
                                  className={
                                    isSubmitSignup
                                      ? `btnVerify disabled`
                                      : `btnVerify blockBtn`
                                  }
                                >
                                  Continue
                                </button>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  </>
                </div>
              </div>
              <>
                {(screentype === 1 || screentype === 2) && (
                  <>
                    <div className="carouselContainer">
                      <span className="carouselText">
                        More reasons to download Abound
                      </span>
                    </div>
                    <div className="carouselBox">
                      <CarouselProvider
                        naturalSlideWidth={100}
                        naturalSlideHeight={116}
                        totalSlides={4}
                        style={{ height: "125px" }}
                        isPlaying={true}
                        lockOnWindowScroll={true}
                        interval={3000}
                      >
                        <Slider style={{ height: "100px" }}>
                          {CRICBUZZ_SLIDER_ITEMS.map((data, index) => {
                            return (
                              <Slide
                                index={index}
                                key={index}
                                style={{ height: "126px" }}
                              >
                                <div className="slideContainer">
                                  <div
                                    className="textContainer"
                                    style={{
                                      background: data.leftSection.background,
                                    }}
                                  >
                                    {data.leftSection.logo ? (
                                      <img
                                        src={data.leftSection.logo}
                                        alt="logo"
                                        className="logoStyle"
                                      />
                                    ) : (
                                      <div className="logoStyle"></div>
                                    )}
                                    <span className="content-text">
                                      {data.leftSection.text1}
                                    </span>
                                    <span className="content-text">
                                      {data.leftSection.text2}
                                    </span>
                                    <span className="content-text">
                                      {data.leftSection.text3}
                                    </span>
                                  </div>
                                  <img
                                    src={data.rightSection.url}
                                    className="slideImg"
                                  />
                                </div>
                              </Slide>
                            );
                          })}
                        </Slider>
                        <DotGroup className="cricbuzzSliderDots" />
                      </CarouselProvider>
                    </div>
                  </>
                )}
              </>
            </div>
          </div>

          <div>
            <div className="rating">
              <span className="text1">Trusted by </span>
              <span className="text2">100k+</span>
              <span className="text1">NRIs</span>

              <img src={star} alt="star" className="imgClass" />
              <img src={star} alt="star" className="imgClass" />
              <img src={star} alt="star" className="imgClass" />
              <img src={star} alt="star" className="imgClass" />
              <img src={star} alt="star" className="imgClass" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Signup;
